/* eslint-disable react/prop-types */
import React from 'react';
import RehypeReact from 'rehype-react';

import AsyncComponent from '@arcblock/ux/lib/Async';
import { addComponents } from '@arcblock/www/src/libs/xmark/components';

import Link from './misc/link';
import CodeBlock from './misc/code';

const GraphQLPlayground = AsyncComponent(() => import('@arcblock/ux/lib/GraphQLPlayground'));
const TerminalPlayer = AsyncComponent(() => import('./misc/player'));

const components = addComponents({
  a: Link,
  pre: CodeBlock,
  graphql: GraphQLPlayground,
  'terminal-player': TerminalPlayer,
});

function createElement(component, props, children) {
  const Component =
    (components && component && components[component]) || // Get component from map if present
    component || // Otherwise just the string
    'div'; // Default to div

  // And return the formed component
  return <Component {...props}>{children}</Component>;
}

export default new RehypeReact({ createElement }).Compiler;
